import { GetStaticPaths, GetStaticProps } from 'next';
import { useRouter } from 'next/router';

import { Stack } from '@arrived/bricks';
import { SEO } from '@arrived/components';
import { useOfferingQuery } from '@arrived/queries';

import { PropertyDetailsStandalone } from '../../../components/properties';
import { PropertyStaticPaths, getPropertyStaticPaths } from '../../../components/properties/getPropertyStaticPaths';
import { PropertyStaticProps, getPropertyStaticProps } from '../../../components/properties/getPropertyStaticProps';

export const PropertyPage = () => {
  const router = useRouter();
  const offeringState = useOfferingQuery(router.query.shortName as string);

  const title = offeringState.data?.name ?? 'Arrived offering';
  const image = offeringState.data?.properties[0]?.photos[0]?.url;
  const description = offeringState?.data?.description ?? 'Details of an Arrived offering';

  return (
    <Stack flex={1}>
      <SEO
        title={title}
        images={image ? [image] : []}
        description={description}
        // Update later with specific property tags
        keywords={['arrived', 'rent', 'home ownership', 'equity', 'investment']}
      />
      <PropertyDetailsStandalone />
    </Stack>
  );
};

export const getStaticPaths: GetStaticPaths<PropertyStaticPaths> = getPropertyStaticPaths;
export const getStaticProps: GetStaticProps<PropertyStaticProps> = getPropertyStaticProps;

PropertyPage.isPropertyDetailsPage = true;
